import React from 'react';

class Counter extends React.Component {
  constructor (props) {
    super(props);
    this.incrementIfOdd=this.incrementIfOdd.bind(this);
    this.incrementAsync=this.incrementAsync.bind(this);
    this.state={value: 0};
  }

  incrementIfOdd() {
    if (this.state.value % 2 !== 0) {
      this.props.onIncrement()
    }
  } 

  incrementAsync() {
    setTimeout(this.props.onIncrement, 1000)
  }

  render() {
    return (
      <p>
        Clicked: {this.state.value} times
        {' '}
        <button onClick={this.props.onIncrement}>+</button>
        {' '}
        <button onClick={this.props.onDecrement}>-</button>
        {' '}
        <button onClick={this.incrementIfOdd}>Incremet if odd</button>
        {' '}
        <button onClick={this.incrementIfAsync}>Incremet async</button>
      </p>
    )
  }
}

export default Counter;



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Counter.js